import React, { useEffect, useState } from "react";
import Header from "../../components/template/website/Header";
import Footer from "../../components/template/estimate/Footer";
import SideBar from "./SideBar";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faUserEdit,
  faReceipt,
} from "@fortawesome/free-solid-svg-icons";
import {
  saveCustomerDetails,
  checkIfUserExists,
  checkAlternatePhoneNumber,
  fetchCustomerProfile,
} from "../../adapters/dashboard/dashboardAdapater";
import { Spinner } from "reactstrap";
import { ConfirmProfileSaveModal } from "../../components/modal/dashboard/ConfirmProfileSave";
import { Alert, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { thunkUpdateUserData } from "../../redux/reducers/user_info/userInfoReducer";
import { useDispatch } from "react-redux";
import {
  onlyNumber,
  validNameFormat,
  validPhoneNumberLength,
  validEmailId,
} from "../../components/common/validationFn";
import { Tooltip } from "reactstrap";

export function MyProfile(props) {
  const [isEditActive, setIsEditActive] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const JSX = (
    <>
      <Header />
      <main className="profile-main-container">
        <div className="container-fluid mt-4">
          <div className="row main-header align-items-start">
            <SideBar />
            <div className="col-sm-12 col-md-12 col-lg-10">
              <div className="profile-container">
                <h3 className="mb-3 dashboard-heading-title">My Profile</h3>
                <Alert
                  color="success"
                  isOpen={success}
                  toggle={() => {
                    setSuccess(false);
                  }}
                >
                  <FontAwesomeIcon icon={faCheckCircle} /> Your profile details
                  is successfully updated.
                </Alert>
                <Alert
                  color="danger"
                  isOpen={error !== "" ? true : false}
                  toggle={() => {
                    setError("");
                  }}
                >
                  <FontAwesomeIcon icon={faExclamationCircle} /> {error}
                </Alert>
                {isEditActive === false && (
                  <ProfileView
                    toggleEdit={setIsEditActive}
                    success={success}
                    setSuccess={setSuccess}
                  />
                )}
                {/* edit form */}
                {isEditActive === true && (
                  <EditProfileForm
                    toggleEdit={setIsEditActive}
                    success={success}
                    setSuccess={setSuccess}
                    error={error}
                    setError={setError}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
  return JSX;
}

function ProfileView(props) {
  const userInfo = useSelector((state) => state.userInfo);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [gstModalOpen, setGstModalOpen] = useState(false);
  const [gstTreatment, setGstTreatment] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [formData, setFormData] = useState({
    companyName: "",
    gstTreatment: "",
    gstin: "",
    businessLegalName: "",
    placeOfSupply: "",
  });
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchProfileData = async () => {
    try {
      const response = await fetchCustomerProfile(userInfo.userId);

      if (response.data.customers && response.data.customers.length > 0) {
        setProfileData(response.data.customers[0]);
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
      // You might want to add error state handling here
    }
  };

  // Update the useEffect to use the extracted function
  useEffect(() => {
    setLoading(true);
    fetchProfileData().finally(() => setLoading(false));
  }, [userInfo.userId]);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  const toggleGstModal = () => {
    setGstModalOpen(!gstModalOpen);
    // Reset form when modal is closed
    if (!gstModalOpen) {
      setFormData({
        companyName: "",
        gstTreatment: "",
        gstin: "",
        businessLegalName: "",
        placeOfSupply: "",
      });
      setGstTreatment("");
      setFormErrors({});
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: null,
      });
    }
  };

  const handleGstTreatmentChange = (e) => {
    const value = e.target.value;
    setGstTreatment(value);
    setFormData({
      ...formData,
      gstTreatment: value,
    });
    // Clear error when selection is made
    if (formErrors.gstTreatment) {
      setFormErrors({
        ...formErrors,
        gstTreatment: null,
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (!formData.companyName.trim()) {
      errors.companyName = "Company Name is required";
      isValid = false;
    }
    if (!formData.gstTreatment) {
      errors.gstTreatment = "GST Treatment is required";
      isValid = false;
    }
    if (formData.gstTreatment === "Registered" && !formData.gstin.trim()) {
      errors.gstin = "GSTIN is required for registered businesses";
      isValid = false;
    }
    if (!formData.businessLegalName.trim()) {
      errors.businessLegalName = "Business Legal Name is required";
      isValid = false;
    }
    if (!formData.placeOfSupply.trim()) {
      errors.placeOfSupply = "Place of Supply is required";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);
    setSubmitError(null);

    try {
      const payload = {
        customer_type: "Business",
        first_name: userInfo.customerName, // Using existing name from userInfo
        email: userInfo.email, // Using existing email from userInfo
        phone: userInfo.phone, // Using existing phone from userInfo
        alternate_phone: userInfo.alternatePhone, // Using existing alternate phone
        is_email_verified: userInfo.isEmailVerified ? 1 : 0,
        is_phone_verified: 1,
        company_name: formData.companyName,
        gst_treatment: formData.gstTreatment,
        business_legal_name: formData.businessLegalName,
        place_of_supply: formData.placeOfSupply,
        gstin: formData.gstTreatment === "Registered" ? formData.gstin : "",
        user_id: userInfo.userId,
      };

      const updateResult = await saveCustomerDetails(payload);

      if (updateResult.data.meta.code === "200") {
        // Success case
        toggleGstModal();
        props.setSuccess(true); // Show success message
        fetchProfileData();
      } else {
        setSubmitError(
          updateResult.data.meta.message || "Failed to update GST details"
        );
      }
    } catch (error) {
      console.error("Error updating GST details:", error);
      setSubmitError(
        error.response?.data?.meta?.message ||
          "An error occurred while updating GST details"
      );
    } finally {
      setIsSubmitting(false);
    }
  };
  if (loading) {
    return (
      <div className="profile-view">
        <div className="text-center">
          <Spinner color="primary" />
          <p>Loading profile data...</p>
        </div>
      </div>
    );
  }

  if (!profileData) {
    return (
      <div className="profile-view">
        <div className="alert alert-danger">
          Failed to load profile data. Please try again later.
        </div>
      </div>
    );
  }
  const JSX = (
    <div className="profile-view">
      <div className="profile-data">
        <label className="form-label">Your Name</label>
        <div className="profile-data-value">
          {profileData.first_name} {profileData.last_name}
        </div>
      </div>
      <div className="profile-data">
        <label className="form-label">
          Email Address{" "}
          {profileData.is_email_verified === "0" && (
            <>
              <Tooltip
                placement="top"
                isOpen={tooltipOpen}
                target="verify_email_exclaimation"
                toggle={toggle}
              >
                Please Verify Email
              </Tooltip>
              <FontAwesomeIcon
                id="verify_email_exclaimation"
                color={"red"}
                icon={faExclamationTriangle}
              />
            </>
          )}
        </label>
        <div className="profile-data-value">{profileData.email}</div>
      </div>
      <div className="profile-data">
        <label className="form-label">Phone Number</label>
        <div className="profile-data-value"> {profileData.phone}</div>
      </div>
      <div className="profile-data">
        <label className="form-label">Alternate Phone Number</label>
        <div className="profile-data-value">
          {profileData.alternate_phone || "Not Provided"}
        </div>
      </div>
      {profileData.customer_type === "Business" && (
        <>
          <div className="profile-data">
            <label className="form-label">Company Name</label>
            <div className="profile-data-value">
              {profileData.company_name || "Not Provided"}
            </div>
          </div>
          <div className="profile-data">
            <label className="form-label">GST Treatment</label>
            <div className="profile-data-value">
              {profileData.gst_treatment || "Not Provided"}
            </div>
          </div>
          {profileData.gst_treatment === "Registered" && (
            <div className="profile-data">
              <label className="form-label">GSTIN</label>
              <div className="profile-data-value">
                {profileData.gstin || "Not Provided"}
              </div>
            </div>
          )}
          <div className="profile-data">
            <label className="form-label">Business Legal Name</label>
            <div className="profile-data-value">
              {profileData.business_legal_name || "Not Provided"}
            </div>
          </div>
          <div className="profile-data">
            <label className="form-label">Place of Supply</label>
            <div className="profile-data-value">
              {profileData.place_of_supply || "Not Provided"}
            </div>
          </div>
        </>
      )}
      <div className="profile-actions">
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={() => {
            props.toggleEdit(true);
            if (props.success === true) {
              props.setSuccess(false);
            }
          }}
        >
          <FontAwesomeIcon icon={faUserEdit} /> Edit
        </button>
        <button
          type="button"
          className="btn btn-secondary btn-sm ml-2"
          onClick={toggleGstModal}
        >
          <FontAwesomeIcon icon={faReceipt} /> Add GST Details
        </button>
      </div>

      <Modal isOpen={gstModalOpen} toggle={toggleGstModal}>
        <ModalHeader toggle={toggleGstModal}>Add GST Details</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label className="form-label">
              Company Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${
                formErrors.companyName ? "is-invalid" : ""
              }`}
              name="companyName"
              value={formData.companyName}
              onChange={handleInputChange}
            />
            {formErrors.companyName && (
              <div className="invalid-feedback">{formErrors.companyName}</div>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">
              GST Treatment <span className="text-danger">*</span>
            </label>
            <select
              className={`form-control ${
                formErrors.gstTreatment ? "is-invalid" : ""
              }`}
              value={gstTreatment}
              onChange={handleGstTreatmentChange}
              name="gstTreatment"
            >
              <option value="">Select GST Treatment</option>
              <option value="Registered">Registered</option>
              <option value="Unregistered">Unregistered</option>
            </select>
            {formErrors.gstTreatment && (
              <div className="invalid-feedback">{formErrors.gstTreatment}</div>
            )}
          </div>

          {/* Conditionally render GSTIN field if Registered is selected */}
          {gstTreatment === "Registered" && (
            <div className="form-group">
              <label className="form-label">
                GSTIN <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  formErrors.gstin ? "is-invalid" : ""
                }`}
                name="gstin"
                value={formData.gstin}
                onChange={handleInputChange}
                placeholder="Enter 15-digit GSTIN"
              />
              {formErrors.gstin && (
                <div className="invalid-feedback">{formErrors.gstin}</div>
              )}
            </div>
          )}

          <div className="form-group">
            <label className="form-label">
              Business Legal Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${
                formErrors.businessLegalName ? "is-invalid" : ""
              }`}
              name="businessLegalName"
              value={formData.businessLegalName}
              onChange={handleInputChange}
            />
            {formErrors.businessLegalName && (
              <div className="invalid-feedback">
                {formErrors.businessLegalName}
              </div>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">
              Place of Supply <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${
                formErrors.placeOfSupply ? "is-invalid" : ""
              }`}
              name="placeOfSupply"
              value={formData.placeOfSupply}
              onChange={handleInputChange}
            />
            {formErrors.placeOfSupply && (
              <div className="invalid-feedback">{formErrors.placeOfSupply}</div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={toggleGstModal}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
  return JSX;
}

function EditProfileForm(props) {
  const { errors, register, handleSubmit, getValues } = useForm();
  const { setError, setSuccess } = props;
  const [isUpdating, setIsUpdating] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);
  const cleanData = (stringData) => {
    return stringData.trim();
  };
  const handleConfirmation = (data) => {
    setFormData(data);
    setConfirmModal(true);
  };
  const submitFn = async (data) => {
    setIsUpdating(true);
    const email = cleanData(data["customer_email"]);
    const first_name = cleanData(data["customer_name"]);
    const phone = cleanData(data["customer_phone_number"]);
    const alternate_phone = cleanData(data["customer_alternate_number"]);
    const body = {
      email: email,
      first_name: first_name,
      phone: phone,
      is_email_verified: "1",
      user_id: userInfo.userId,
      alternate_phone: alternate_phone,
    };
    let isDuplicateEmail = false;
    let isDuplicatePhone = false;
    if (email !== userInfo.email) {
      try {
        const duplicateEmailCheck = await checkIfUserExists({
          mobile: phone,
          emailID: email,
          loginType: "email",
        });
        // console.log("email check", duplicateEmailCheck);
        if (duplicateEmailCheck.status === 200) {
          if (duplicateEmailCheck.data.meta.code === 200) {
            isDuplicateEmail = true;
          }
        }
      } catch (e) {
        if (e.response.status === 404) {
          if (parseInt(e.response.data.meta.code) === 404) {
            isDuplicateEmail = false;
          }
        } else {
          setError("An Error Occurred while updating your profile");
          setIsUpdating(false);
          return;
        }
      }
    }
    if (phone !== userInfo.phone) {
      try {
        const duplicatePhoneCheck = await checkIfUserExists({
          mobile: phone,
          emailID: email,
          loginType: "mobile",
        });
        // console.log("mobile check", duplicatePhoneCheck);
        if (duplicatePhoneCheck.status === 200) {
          if (duplicatePhoneCheck.data.meta.code === 200) {
            isDuplicatePhone = true;
          }
        }
      } catch (e) {
        if (e.response.status === 404) {
          if (parseInt(e.response.data.meta.code) === 404) {
            isDuplicateEmail = false;
          }
        } else {
          setError("An Error Occurred while updating your profile");
          setIsUpdating(false);
          return;
        }
      }
    }
    try {
      if (isDuplicateEmail === true && isDuplicatePhone === true) {
        setError("Email and Phone already exists.");
        setIsUpdating(false);
      } else if (isDuplicateEmail === true && isDuplicatePhone === false) {
        setError("Email already exists.");
        setIsUpdating(false);
      } else if (isDuplicateEmail === false && isDuplicatePhone === true) {
        setError("Primary Phone number already exists.");
        setIsUpdating(false);
      } else if (isDuplicateEmail === false && isDuplicatePhone === false) {
        if (alternate_phone !== "") {
          const validateAlternatePhoneNumber = await checkAlternatePhoneNumber({
            user_id: userInfo.userId,
            alternate_number: alternate_phone,
            new_primary_phone_number: phone,
          });
          if (
            validateAlternatePhoneNumber.data.meta.code === 200 &&
            validateAlternatePhoneNumber.data.meta.status === "OK"
          ) {
            if (
              validateAlternatePhoneNumber.data.meta.message ===
              "same_number_entry"
            ) {
              //same primary and secondary number
              setError(
                "alternate phone number cannot be same as primary number."
              );
              setIsUpdating(false);
              return;
            }
            if (
              validateAlternatePhoneNumber.data.meta.message ===
              "duplicate_alternate_number"
            ) {
              // alternate number already used by another user
              setError("alternate number is already used.");
              setIsUpdating(false);
              return;
            }
          }
        }
        await updateCustomerData(body, isDuplicateEmail);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const updateCustomerData = async (body, isDuplicateEmail) => {
    try {
      if (body["email"] !== userInfo.email && isDuplicateEmail === false) {
        body["is_email_verified"] = "0";
      }
      const updateResult = await saveCustomerDetails(body);
      console.log("update result", updateResult);
      setIsUpdating(false);

      if (updateResult.status === 200) {
        if (updateResult.data.meta.code === "200") {
          const responseData = updateResult.data.data;

          const payload = {
            email: responseData["email"],
            phone: responseData["phone"],
            alternatePhone: responseData["alternate_phone"],
            customerName: responseData["first_name"],
            isEmailVerified: responseData["is_email_verified"],
          };
          dispatch(thunkUpdateUserData(payload));
          setSuccess(true);
          props.toggleEdit(false);
          setFormData(null);
        }
      }
    } catch (e) {
      setError("An Error Occurred while updating your profile");
      setIsUpdating(false);
      console.log("An Error Occurred", e);
    }
  };
  const validRequired = (value) => {
    return value.trim() === "" ? false : true;
  };
  const JSX = (
    <>
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <div className="profile-form-container">
            <form
              name="customer_profile_form"
              onSubmit={handleSubmit(handleConfirmation)}
            >
              <div className="form-group mb-0">
                <label className="form-label" htmlFor="customer_name">
                  Your Name
                </label>
                <input
                  type="text"
                  ref={register({
                    required: true,
                    maxLength: 50,
                    minLength: 3,
                    validate: {
                      validNameFormat: validNameFormat,
                      validRequired: validRequired,
                    },
                  })}
                  className="form-control"
                  defaultValue={userInfo.customerName}
                  id="customer_name"
                  name="customer_name"
                />
                <span className="error-text">
                  {errors.customer_name &&
                    errors.customer_name.type === "required" &&
                    "This field is required."}
                  {errors.customer_name &&
                    errors.customer_name.type === "validRequired" &&
                    "This field is required."}
                  {errors.customer_name &&
                    errors.customer_name.type === "validNameFormat" &&
                    "Please enter only alphabets."}
                  {errors.customer_name &&
                    errors.customer_name.type === "maxLength" &&
                    "Maximum characters allowed is 50."}
                  {errors.customer_name &&
                    errors.customer_name.type === "minLength" &&
                    "Please enter minimum 3 characters."}
                </span>
              </div>
              <div className="form-group mb-0">
                <label className="form-label" htmlFor="customer_email">
                  Email Address
                </label>
                <input
                  type="text"
                  className="form-control"
                  ref={register({
                    required: true,
                    maxLength: 100,
                    validate: { validEmailId: validEmailId },
                  })}
                  id="customer_email"
                  defaultValue={userInfo.email}
                  name="customer_email"
                />
                <span className="error-text">
                  {errors.customer_email &&
                    errors.customer_email.type === "required" &&
                    "This field is required."}
                  {errors.customer_email &&
                    errors.customer_email.type === "validEmailId" &&
                    "Please enter a valid email id."}
                  {errors.customer_email &&
                    errors.customer_email.type === "maxLength" &&
                    "Maximum characters allowed is 100."}
                </span>
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="customer_phone_number">
                  Phone Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  ref={register({
                    required: true,
                    validate: {
                      onlyNumber: onlyNumber,
                      validPhoneNumberLength: validPhoneNumberLength,
                    },
                  })}
                  id="customer_phone_number"
                  defaultValue={userInfo.phone}
                  name="customer_phone_number"
                />
                <span className="error-text">
                  {errors.customer_phone_number &&
                    errors.customer_phone_number.type === "required" &&
                    "This field is required."}
                  {errors.customer_phone_number &&
                    errors.customer_phone_number.type === "onlyNumber" &&
                    "Please enter only numbers."}
                  {errors.customer_phone_number &&
                    errors.customer_phone_number.type ===
                      "validPhoneNumberLength" &&
                    "Please enter 10 digit number."}
                </span>
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="customer_phone_number">
                  Alternate Phone Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  ref={register({
                    validate: {
                      onlyNumber: (value) => /^[0-9]*$/.test(value),
                      validPhoneNumberLength: (value) =>
                        value.length === 10 || value.length === 0
                          ? true
                          : false,
                      isSimilarPrimaryAndSecondayNumber: (value) => {
                        if (value.trim() === "") {
                          return true;
                        }
                        return (
                          getValues("customer_phone_number") !== value.trim()
                        );
                      },
                    },
                  })}
                  id="customer_alternate_number"
                  defaultValue={userInfo.alternatePhone}
                  name="customer_alternate_number"
                />
                <span className="error-text">
                  {errors.customer_alternate_number &&
                    errors.customer_alternate_number.type === "onlyNumber" &&
                    "Please enter only numbers."}
                  {errors.customer_alternate_number &&
                    errors.customer_alternate_number.type ===
                      "validPhoneNumberLength" &&
                    "Please enter 10 digit number."}
                  {errors.customer_alternate_number &&
                    errors.customer_alternate_number.type ===
                      "isSimilarPrimaryAndSecondayNumber" &&
                    "Primary and secondary phone cannot be same"}
                </span>
              </div>
              <div className="form-group mb-0">
                {isUpdating === true && (
                  <button className="btn btn-primary btn-sm">
                    <Spinner color={"light"} /> Updating...
                  </button>
                )}

                {isUpdating === false && (
                  <button
                    type="button"
                    onClick={() => handleSubmit(handleConfirmation)()}
                    className="btn btn-primary btn-sm"
                  >
                    Save Changes
                  </button>
                )}

                <button
                  type="button"
                  disabled={isUpdating === true ? true : false}
                  onClick={() => props.toggleEdit(false)}
                  className="btn btn-dark btn-sm ml-2"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ConfirmProfileSaveModal
        modal={confirmModal}
        onYes={() => {
          setConfirmModal(false);
          if (formData !== null) {
            submitFn(formData);
          }
        }}
        onNo={() => {
          setConfirmModal(false);
        }}
      />
    </>
  );
  return JSX;
}
